import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../apps/consumer/graphql/fragments/global';

const getAccountCardRosterIdentityConfigurationPhotosQuery = gql`
  query getAccountCardRosterIdentityConfigurationPhotosQuery(
    $roster_identity_ids: [RecordID]!
    $limit: Int = 40
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $allPhotosOffset: Int = 0
    $faceHighlightOffset: Int = 0
  ) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          photos {
            face_highlighted_photos(
              slice: { limit: $limit, offset: $faceHighlightOffset }
            ) {
              total
              records {
                id
                thumbnail_urls(ignore_watermark: true) {
                  ...PhotoUrlTypeFields
                }
              }
            }
            matched_photos(slice: { limit: $limit, offset: $matchesOffset }) {
              total
              records {
                id
                thumbnail_urls(ignore_watermark: true) {
                  ...PhotoUrlTypeFields
                }
                faces {
                  total
                }
              }
            }
            favorited_photos(
              slice: { limit: $limit, offset: $favoritesOffset }
            ) {
              total
              records {
                id
                thumbnail_urls(ignore_watermark: true) {
                  ...PhotoUrlTypeFields
                }
              }
            }
            all_photos(slice: { limit: $limit, offset: $allPhotosOffset }) {
              total
              records {
                id
                thumbnail_urls(ignore_watermark: true) {
                  ...PhotoUrlTypeFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export default getAccountCardRosterIdentityConfigurationPhotosQuery;
